// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"be5023a18ee46cad58b9","691":"9e2ec4734d3416ba7805"}[chunkId] + ".js";
};